export type ViewMode = 'grid' | 'list';

// What the user picked. `system` follows the OS colour-scheme.
export type ThemeMode = 'light' | 'dark' | 'system';

// What actually gets painted — `system` is resolved to one of these.
export type ResolvedTheme = 'light' | 'dark';

export type Preferences = {
    defaultView: ViewMode;
    themeMode: ThemeMode;
};

export const defaultPreferences: Preferences = {
    defaultView: 'grid',
    themeMode: 'system',
};
